import { fabric } from 'fabric';

export class CanvasManager {

  /**
   * Create and return a fabric canvas item.
   * @param element Name, selector or reference to a HTML canvas element (such Angular's ElementRef)
   * @param options Standard options for the canvas element
   */
  public static createCanvas(element: string | HTMLCanvasElement, options?: fabric.ICanvasOptions): fabric.Canvas {
    return new fabric.Canvas(element, options);
  }

  /**
   * Create and return a fabric canvas item that DOES NOT have interactivity
   * @param element Name, selector or reference to a HTML canvas element (such Angular's ElementRef)
   * @param options Standard options for the canvas element
   */
   public static createStaticCanvas(element: string | HTMLCanvasElement, options?: fabric.ICanvasOptions): fabric.StaticCanvas {
    return new fabric.StaticCanvas(element, options);
  }
}
